export default [
  {
    field: 'verify',
    method: 'isEmpty',
    validWhen: false,
    message: 'Verification code is required',
  },
  {
    field: 'verify',
    method: 'isLength',
    validWhen: true,
    message: 'Verification code date must a 6 digit number',
    options: [{ min: 6, max: 6 }],
  },
  {
    field: 'verify',
    method: 'isInt',
    validWhen: true,
    message: 'Verification code date must a 6 digit number',
  },
];
